import { Injectable } from '@angular/core';

/**
 * Global API Configuration.
 */
@Injectable()
export class ApiConfiguration {
  public rootUrl: string = '/';
}
